import { render } from "./detailed-information-screen.vue?vue&type=template&id=4b07aa9e&scoped=true"
import script from "./detailed-information-screen.vue?vue&type=script&lang=js"
export * from "./detailed-information-screen.vue?vue&type=script&lang=js"

import "./detailed-information-screen.vue?vue&type=style&index=0&id=4b07aa9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b07aa9e"]])

export default __exports__